<!-- HEADER -->
<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Bulk Posts Section
      </p>
      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        List
      </h2>
    </div>
  </div>
</div>

<!-- CONTENT WRAPPER -->
<div class="bg-gray-50 px-3 pb-10 min-h-screen pt-6">
  <div class="grid grid-cols-12 gap-6 items-start">
    <div class="col-span-12 2xl:col-span-9">
      <div class="w-full bg-white rounded-3xl border border-gray-300 p-6">

      <!-- Top bar: upload button + paginator -->
      <div class="grid grid-cols-12 mb-4">
        <div class="col-span-6 flex justify-start ps-2">
          <button class="primary-btn mb-4 h-[50px]" (click)="createBulkPost()">
            Upload Bulk File
          </button>
        </div>

        <div class="col-span-12 sm:col-span-6">
          <div class="flex justify-end mt-6">
            <mat-paginator
              [length]="totalItems"
              [pageSize]="pageSize"
              [pageSizeOptions]="[pageSize]"
              showFirstLastButtons
              style="background-color: white;"
              (page)="onPageChange($event)"
            >
            </mat-paginator>
          </div>
        </div>
      </div>

      <!-- MOBILE -->
      <div class="sm:hidden">
        <div
          *ngFor="let element of dataSource.data"
          class="mb-4 bg-white border border-gray-300 rounded-2xl p-4"
        >

          <div class="mb-3">
            <p class="text-xs text-gray-400 uppercase">File</p>
            <p class="font-medium text-gray-700 break-all">{{ element.file_name }}</p>
          </div>

          <div class="grid grid-cols-2 gap-3 text-sm">
            <div>
              <p class="text-gray-400 text-xs">Valid Posts</p>
              <p class="text-green-600 font-semibold">{{ element.valid_rows }}</p>
            </div>

            <div>
              <p class="text-gray-400 text-xs">Invalid Posts</p>
              <p class="text-red-600 font-semibold">{{ element.failed_posts_count }}</p>
            </div>

            <div class="col-span-2">
              <p class="text-gray-400 text-xs">Uploaded</p>
              <p class="text-gray-700">{{ element.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
          </div>

          <div class="grid grid-cols-3 gap-2 mt-4">
            <button
              class="border border-gray-300 rounded-lg py-2 text-sm text-gray-700"
              (click)="expandedElement = expandedElement === element ? null : element; expandedErrorLogsElement = null"
            >
              View Posts
            </button>

            <button
              class="border border-red-200 rounded-lg py-2 text-sm text-red-600"
              (click)="expandedErrorLogsElement = expandedErrorLogsElement === element ? null : element; expandedElement = null"
            >
              Errors
            </button>

            <button
              type="button"
              class="border border-red-300 rounded-lg py-2 text-sm font-medium text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
              [disabled]="deletingBulkId === element.id"
              (click)="deleteBulkUpload(element)"
            >
              {{ deletingBulkId === element.id ? 'Deleting...' : 'Delete' }}
            </button>
          </div>

          <!-- Mobile expanded: posts -->
          <div *ngIf="expandedElement === element" class="mt-4 border-t border-gray-300 pt-4">
            <h4 class="font-semibold text-gray-700 mb-3">Posts</h4>

            <ng-container *ngIf="element.posts?.length; else noMobilePosts">
              <div
                *ngFor="let post of element.posts"
                class="border border-gray-300 rounded-xl p-3 mb-3 text-sm"
              >
                <div><strong>Site:</strong> {{ post.content_site }}</div>
                <div><strong>Category:</strong> {{ post.feed }}</div>
                <div><strong>Title:</strong> {{ post.rss_title }}</div>
                <div><strong>Platform:</strong> {{ post.platform }}</div>
              </div>
            </ng-container>

            <ng-template #noMobilePosts>
              <p class="text-gray-400 text-sm">No posts available.</p>
            </ng-template>
          </div>

          <!-- Mobile expanded: errors -->
          <div *ngIf="expandedErrorLogsElement === element" class="mt-4 border-t border-gray-300 pt-4">
            <h4 class="font-semibold text-red-600 mb-3">Error Logs</h4>

            <ng-container *ngIf="element.failed_posts?.length; else noMobileErrors">
              <div
                *ngFor="let failed of element.failed_posts"
                class="bg-red-50 border border-red-100 rounded-xl p-3 mb-3 text-sm"
              >
                <div><strong>Row:</strong> {{ failed.row_number }}</div>
                <div><strong>Message:</strong> {{ failed.error_messages.message }}</div>
              </div>
            </ng-container>

            <ng-template #noMobileErrors>
              <p class="text-gray-400 text-sm">No error logs found.</p>
            </ng-template>
          </div>

        </div>
      </div>

      <!-- DESKTOP -->
      <div class="hidden sm:block">

        <!-- Column headers -->
        <div
          class="grid gap-x-3 px-4 pb-2 text-[11px] font-medium uppercase tracking-wide text-gray-400"
          style="grid-template-columns: minmax(0,3fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1.2fr) minmax(0,1.2fr) minmax(0,1fr) minmax(0,0.9fr);"
        >
          <span>File name</span>
          <span class="text-center">Valid</span>
          <span class="text-center">Invalid</span>
          <span class="text-center">Posts</span>
          <span class="text-center">Errors</span>
          <span>Uploaded</span>
          <span class="text-center">Actions</span>
        </div>

        <!-- Row cards -->
        <ng-container *ngFor="let element of dataSource.data">

          <div
            class="grid gap-x-3 items-center bg-white border border-gray-300 rounded-2xl px-4 py-3 mb-2 cursor-pointer transition-colors duration-150 hover:border-gray-300"
            style="grid-template-columns: minmax(0,3fr) minmax(0,1fr) minmax(0,1fr) minmax(0,1.2fr) minmax(0,1.2fr) minmax(0,1fr) minmax(0,0.9fr);"
            [class.rounded-b-none]="expandedElement === element || expandedErrorLogsElement === element"
            [class.border-b-0]="expandedElement === element || expandedErrorLogsElement === element"
          >

            <!-- File name -->
            <span class="text-[13px] text-gray-700 truncate" [matTooltip]="element.file_name">
              {{ element.file_name }}
            </span>

            <!-- Valid posts -->
            <span class="text-[13px] text-green-600 font-medium text-center">
              {{ element.valid_rows }}
            </span>

            <!-- Invalid posts -->
            <span class="text-[13px] text-red-500 font-medium text-center">
              {{ element.failed_posts_count }}
            </span>

            <!-- Post list toggle -->
            <div class="flex justify-center">
              <button
                class="inline-flex items-center gap-1 text-[12px] text-gray-400 hover:text-indigo-500 transition-colors duration-150"
                (click)="expandedElement = expandedElement === element ? null : element; expandedErrorLogsElement = null"
              >
                <mat-icon
                  class="!text-base !w-4 !h-4 transition-transform duration-200"
                  [class.rotate-180]="expandedElement === element"
                >
                  keyboard_arrow_down
                </mat-icon>
                {{ expandedElement === element ? 'Collapse' : 'View posts' }}
              </button>
            </div>

            <!-- Error list toggle -->
            <div class="flex justify-center">
              <button
                class="inline-flex items-center gap-1 text-[12px] text-gray-400 hover:text-rose-500 transition-colors duration-150"
                (click)="expandedErrorLogsElement = expandedErrorLogsElement === element ? null : element; expandedElement = null"
              >
                <mat-icon
                  class="!text-base !w-4 !h-4 transition-transform duration-200"
                  [class.rotate-180]="expandedErrorLogsElement === element"
                >
                  keyboard_arrow_down
                </mat-icon>
                {{ expandedErrorLogsElement === element ? 'Collapse' : 'View errors' }}
              </button>
            </div>

            <!-- Uploaded -->
            <div class="text-[12px] text-gray-600 leading-tight">
              <span>{{ element.created_at | date:'dd/MM/yyyy' }}</span><br>
              <span class="text-[11px] text-gray-400">{{ element.created_at | date:'HH:mm' }}</span>
            </div>

            <!-- Delete -->
            <div class="flex justify-center">
              <button
                type="button"
                class="inline-flex items-center gap-1 rounded-lg border border-red-300 px-3 py-1.5 text-[12px] font-medium text-red-600 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
                [disabled]="deletingBulkId === element.id"
                (click)="deleteBulkUpload(element); $event.stopPropagation()"
              >
                <mat-icon class="!text-base !w-4 !h-4">
                  {{ deletingBulkId === element.id ? 'hourglass_empty' : 'delete' }}
                </mat-icon>
                {{ deletingBulkId === element.id ? 'Deleting' : 'Delete' }}
              </button>
            </div>

          </div>

          <!-- Expanded: posts -->
          <div
            *ngIf="expandedElement === element"
            class="border border-t-0 border-gray-300 rounded-b-2xl px-4 pb-4 pt-3 mb-2 bg-gray-50"
          >
            <h4 class="text-[12px] font-medium text-gray-600 uppercase tracking-wide mb-3">Posts</h4>

            <ng-container *ngIf="element.posts?.length; else noPosts">
              <div
                *ngFor="let post of element.posts"
                class="bg-white border border-gray-300 rounded-xl p-3 mb-2 text-[12px] text-gray-700 flex justify-between items-start hover:border-gray-300 transition-colors"
              >
                <div class="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-1 w-full pr-8">
                  <div><span class="text-gray-400">Site:</span> {{ post.content_site }}</div>
                  <div><span class="text-gray-400">Category:</span> {{ post.feed }}</div>
                  <div><span class="text-gray-400">Title:</span> {{ post.rss_title }}</div>
                  <div><span class="text-gray-400">Tag:</span> {{ post.tag }}</div>
                  <div><span class="text-gray-400">Platform:</span> {{ post.platform }}</div>
                  <div><span class="text-gray-400">Week day:</span> {{ weekDays[post.week_day] }}</div>
                  <div><span class="text-gray-400">Status:</span> {{ post.post_status }}</div>
                  <div><span class="text-gray-400">Scheduled:</span> {{ post.scheduled_for | date:'dd/MM/yyyy HH:mm' }}</div>
                  <div><span class="text-gray-400">Source:</span> {{ post.source }}</div>
                </div>

                <button
                  mat-icon-button
                  color="primary"
                  (click)="editRow(post)"
                  matTooltip="Edit post"
                  class="shrink-0"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </ng-container>

            <ng-template #noPosts>
              <p class="text-[12px] text-gray-400 italic">No posts available.</p>
            </ng-template>
          </div>

          <!-- Expanded: errors -->
          <div
            *ngIf="expandedErrorLogsElement === element"
            class="border border-t-0 border-gray-300 rounded-b-2xl px-4 pb-4 pt-3 mb-2 bg-gray-50"
          >
            <h4 class="text-[12px] font-medium text-red-500 uppercase tracking-wide mb-3">Error logs</h4>

            <ng-container *ngIf="element.failed_posts?.length; else noLogs">
              <div
                *ngFor="let failed of element.failed_posts"
                class="bg-red-50 border border-red-100 rounded-xl p-3 mb-2 text-[12px] text-gray-700 hover:bg-red-100 transition-colors"
              >
                <div><span class="text-gray-400">Row:</span> {{ failed.row_number }}</div>
                <div><span class="text-gray-400">Message:</span> {{ failed.error_messages.message }}</div>
              </div>
            </ng-container>

            <ng-template #noLogs>
              <p class="text-[12px] text-gray-400 italic">No error logs found.</p>
            </ng-template>
          </div>

        </ng-container>

        <!-- Empty state -->
        <div
          *ngIf="dataSource.data.length === 0"
          class="flex items-center justify-center py-16 text-gray-400 text-sm bg-white border border-gray-300 rounded-2xl"
        >
          <mat-icon class="mr-2 text-gray-300">inbox</mat-icon>
          No bulk posts found
        </div>

        <!-- Bottom paginator -->
        <div class="flex justify-end mt-4">
          <mat-paginator
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageSizeOptions]="[pageSize]"
            showFirstLastButtons
            style="background-color: white;"
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>

      </div>

    </div>
  </div>

  <div class="hidden md:block col-span-12 2xl:col-span-3">
    <app-sidebar></app-sidebar>
  </div>

</div>
</div>
